import {EntityStoreUser} from 'constants/EntityStoreConstants';
import Licenses from 'user/Licenses';

export function hasUnlimitedSpace(currentUser: EntityStoreUser): boolean {
  if (Licenses.hasEnterprisePlan()) {
    return true;
  }
  if (currentUser.institution?.hasUnlimitedSpace) {
    return true;
  }
  return false;
}
